// returns localized short time format
// given 2020-10-02T21:30:00Z returns `2:30 PM`
const shortTime = (date) => {
  const dtf = new Intl.DateTimeFormat('en-us', {
    hour: 'numeric',
    minute: 'numeric'
  });
  return dtf.format(date);
};

// returns localized short date format with weekday
// given 2020-10-02T21:30:00Z returns `Fri, Oct 2`
const shortDate = (date) => {
  const dtf = new Intl.DateTimeFormat('en-us', {
    month: 'short',
    day: 'numeric',
    weekday: 'short'
  });
  return dtf.format(date);
};

// returns localized long date format with weekday
// given 2020-10-02T21:30:00Z returns `Friday, October 2`
const longDate = (date) => {
  const dtf = new Intl.DateTimeFormat('en-us', {
    month: 'long',
    day: 'numeric',
    weekday: 'long'
  });
  return dtf.format(date);
};

export default { shortTime, shortDate, longDate };
